import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from './main'
import SmallBusiness from './smallBusiness'
import LargeEnterprise from './largeEnterprise'
import Freelancer from './freelancer'
import Partner from './partner'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: '/getting-started',
    fallback: true,
    routes: [{
            path: '/',
            name: 'main',
            component: Main
        },
        {
            path: '/small-business',
            name: 'small-business',
            component: SmallBusiness
        },
        {
            path: '/large-enterprise',
            name: 'large-enterprise',
            component: LargeEnterprise
        },
        {
            path: '/freelancer',
            name: 'freelancer',
            component: Freelancer
        },
        {
            path: '/partner',
            name: 'partner',
            component: Partner
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    }
})

export default router